import { flexColumn } from 'hfty-styles/src/mixins'

export const styles = {
  h3: {
    alignSelf: 'center',
  },
  addressForm: {
    ...flexColumn('flex-start', 'flex-end'),
    width: 350,
    marginLeft: 50,
    padding: '0 0 25px 50px',
    borderLeft: '1px solid rgb(240, 240, 240)',
  },
  formField: {
    width: '100%',
  },
  formTextField: {
    width: '100%',
  },

  selectWrapper: {
    margin: '1em 0 .5em',
    width: '100%',
  },
  select: {
    fontSize: '.875em',
    letterSpacing: '.04em',
  },
  selectLabel: {
    display: 'inline-block',
    fontSize: '.65em',
    letterSpacing: '.56px',
    marginBottom: '1em',
    color: 'var(--mdc-theme-text-hint-on-light,rgba(0,0,0,.38))',
  },
}
